import { Alert, Button } from "antd"
import React from "react"
import { useTranslation } from "react-i18next"
import { DiamondIcon } from "~Components/icons/DiamondIcon"
import { useIsPurchaseOrderEnabled } from "~Shared/hooks/featureFlags.hooks"
import { openWindowInNewTab } from "~Shared/utils/window.utils"

export const DeliveryNoteBillingBanner = () => {
    const { t } = useTranslation()
    const isPurchaseOrderEnabled = useIsPurchaseOrderEnabled()

    const onClickMoreInfo = () => {
        openWindowInNewTab({ url: t("info:delivery_note:billing.link") })
    }

    if (isPurchaseOrderEnabled) {
        return null
    }

    return (
        <Alert
            type="info"
            className="mb-40 items-center"
            closable={false}
            showIcon={true}
            icon={
                <div className="self-start text-base pt-5">
                    <DiamondIcon width={24} height={20} />
                </div>
            }
            message={<span className="font-bold">{t("info:delivery_note:billing.message")}</span>}
            description={
                <>
                    <p>{t("info:delivery_note:billing.description_1")}</p>
                    <p className="font-bold">{t("info:delivery_note:billing.description_2")}</p>
                </>
            }
            action={
                <Button onClick={onClickMoreInfo} className="bg-finway-blue text-white ">
                    {t("info:delivery_note:billing.more_info")}
                </Button>
            }
        />
    )
}
